class FooterNewsletter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let formValidated = [];
    const newsletterForm = this.querySelector('.newsletter-form');
    const emailInput = this.querySelector('#newsletter-email');

    // Function to clear previous confirmation messages
    function clearConfirmationMessages() {
      const confirmationMessages = newsletterForm.parentElement.querySelectorAll('p[data-newsletter-confirmation]');
      confirmationMessages.forEach((msg) => msg.remove());
    }

    function postForm(urlData) {
      // Clear any previous confirmation messages before submitting
      clearConfirmationMessages();

      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST', // or 'PUT'
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        body: urlData,
      })
        .then((response) => response.json())
        .then((data) => {
          // if (window.Shopify.customerPrivacy.marketingAllowed()) {
          //   amzn('trackEvent', 'Subscribe');
          // }
          emailInput.value = '';

          const newSpan = document.createElement('p');
          newSpan.innerHTML = "You're Added.";
          newSpan.style.color = 'green';
          newSpan.style.paddingTop = '0.5rem';
          newSpan.setAttribute('data-newsletter-confirmation', 'true');
          newsletterForm.insertAdjacentElement('afterend', newSpan);
        })
        .catch((error) => {
          alert(error);
        });
    }

    // Clear confirmation messages when email input is focused
    if (emailInput) {
      emailInput.addEventListener('focus', clearConfirmationMessages);
    }

    this.querySelector('.newsletter__submit').addEventListener('click', (e) => {
      const data = {
        g: this.getAttribute('list-id'),
        $fields: 'event, $source',
        $source: 'Footer Newsletter',
        email: emailInput.value,
      };

      this.querySelectorAll('.form-field').forEach((e, index) => {
        const key = e.id.replace(/-/g, '_');
        const value = e.value;
        data.$fields += `, ${key}`;
        data[key] = value;
      });

      const urlData = new URLSearchParams(data);
      this.querySelectorAll('input').forEach((e, index) => {
        if (e.reportValidity() == false) {
          formValidated[index] = false;
        } else {
          formValidated[index] = true;
        }
      });

      let checker = (arr) => arr.every(Boolean);
      if (checker(formValidated) == false) {
      } else {
        postForm(urlData);
      }
    });
  }
}

customElements.define('footer-newsletter', FooterNewsletter);
